<template>
    <div v-if="mode === 'show'" class="mb-3">
        <img :src="src" class="img-fluid rounded w-100 mb-3">
        <button type="button" class="btn btn-block btn-primary" @click="mode = 'upload'">Сменить изображение</button>
    </div>
    <div v-else-if="mode === 'upload'">
        <div class="mb-3">
            <div class="embed-responsive embed-responsive-16by9 rounded mb-3" v-show="original">
                <vue-cropper
                    :key="componentKey"
                    :src="original"
                    :aspect-ratio="aspectRatio"
                    :view-mode="viewMode"
                    :crop-box-resizable="cropBoxResizable"
                    :auto-crop-area="autoCropArea"
                    :zoom-on-touch="zoomOnTouch"
                    :toggle-drag-mode-on-dblclick="toggleDragModeOnDblclick"
                    :drag-mode="dragMode"
                    :crop="_onCrop"
                    class="embed-responsive-item"
                >
                </vue-cropper>
            </div>
            <v-file value="Выберите изображение..." label="Выбрать" accept="image/*" @change="_onChange"></v-file>
        </div>
        <slot v-bind="this"></slot>
    </div>
</template>

<script>
    import input from '../mixins/input';
    export default {
        name: 'VImageUploader',
        mixins: [
            input,
        ],
        props: {
            name: {
                type: String,
            },
            src: {
                type: String,
                required: true,
            },
            // TODO: свойство приходиться мутировать (подумать о выносе его в data)
            mode: {
                type: String,
                default: 'show',
                validator: function (value) {
                    return ['show', 'upload'].indexOf(value) !== -1;
                }
            },
            'resize-width': {
                type: Number,
                default: -1,
            },
            'resize-height': {
                type: Number,
                default: -1,
            },
            'aspect-ratio': {
                type: Number,
                default: 16 / 9,
            },
            'view-mode': {
                type: Number,
                default: 1,
            },
            'crop-box-resizable': {
                type: Boolean,
                default: true,
            },
            'auto-crop-area': {
                type: Number,
                default: 1,
            },
            'zoom-on-touch': {
                type: Boolean,
                default: true,
            },
            'toggle-drag-mode-on-dblclick': {
                type: Boolean,
                default: false,
            },
            'drag-mode': {
                type: String,
                default: 'move',
            },
        },
        data() {
            return {
                file: null,
                original: null,
                crop: {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                },
                resize: {
                    width: this.resizeWidth,
                    height: this.resizeHeight,
                },
            };
        },
        computed: {
            isIgnored() {
                return this.mode !== 'upload';
            },
            componentKey() {
                return this.file ? this.file.name : null;
            },
        },
        methods: {
            _onChange(files) {
                if (this.original) URL.revokeObjectURL(this.original);
                if(files[0] && /^image\/\w+/.test(files[0].type)) {
                    this.file = files[0];

                    this.original = URL.createObjectURL(this.file);
                } else {
                    this.resetData();

                    swal({
                        icon: "error",
                        title: 'Ошибка',
                        text: "Можно загрузить только изображение.",
                        buttons: {
                            cancel: {
                                text: "Хорошо",
                                value: false,
                                visible: true,
                                className: "btn btn-danger px-4",
                                closeModal: true,
                            },
                        },
                    });
                }
            },
            _onCrop(event) {
                this.crop.x = Math.round(event.detail.x);
                this.crop.y = Math.round(event.detail.y);
                this.crop.width = Math.round(event.detail.width);
                this.crop.height = Math.round(event.detail.height);
            }
        },
    }
</script>
